import {
	AlternativeAuthParams,
	UpdateUserResponse,
	createPinCode,
} from "@/api/register";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";

type CreatePinCodeArgs = {
	auth: AlternativeAuthParams;
	pinCode: string;
};

export default function useCreatePinCode(
	options?: MutationOptionsWithoutFn<UpdateUserResponse, CreatePinCodeArgs>,
) {
	return useMutation({
		...options,
		mutationFn: async ({ auth, pinCode }: CreatePinCodeArgs) =>
			await createPinCode(auth, pinCode),
	});
}
